import PWAInstallerPrompt from "react-pwa-installer-prompt";

const Prompt = () => {
  return (
    <PWAInstallerPrompt
      render={({ onClick }) => (
        <button
          type='button'
          onClick={onClick}
        >
          make sure you pass onClick Install
        </button>
      )}
      callback={(data) => console.log(data)}
    />
  );
};
export default Prompt;
